import React from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import CustomerDetailPage from "../../../CustomersPage/CustomerDetailPage"
import CustomersPage from "../../../CustomersPage/components/CustomersPage.tsx"

export const customerRoutes: RouteObject[] = [
  {
    path: RoutesPaths.customers.list,
    element: (
      <PermissionGate pages={["customers"]}>
        <CustomersPage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.customers.view(":id"),
    element: (
      <PermissionGate
        description={"You don't have permission to view customers."}
        paths={["customers.customers.customer_view"]}
      >
        <CustomerDetailPage />
      </PermissionGate>
    )
  }
]
